module.exports = __webpack_public_path__ + "static/media/personal_text_mpm.ad3245cd.xlsx";